'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { EventDetail } from '@eliadmin/core/src/api/events/events-api';

import { CarouselSection } from '../../shared/carousel-section';
import { CarouselControls } from '@eliadmin/core/src/components/ui/carousel-controls';
import { CgArrowLeft, CgArrowRight } from 'react-icons/cg';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { useState } from 'react';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';

export function EventGallery({ event }: { event: EventDetail }) {
  const { t } = useTranslations();

  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <CarouselSection
        subtitle={t('text2204')}
        title={t('text2203')}
        className={{
          section: 'bg-[#F6F6F6] py-12 sm:py-20 md:py-24 lg:py-[120px]',
          heading_container: { heading: { title: 'text-black', subtitle: 'uppercase' } },
          carousel_container: {
            carousel: {
              container: 'gap-4 lg:gap-5',
              slide:
                'relative h-[550px] w-full max-w-[320px] sm:h-[600px] sm:max-w-[360px] lg:h-[640px]',
            },
          },
        }}
        slides={event?.images.map((image, index) => (
          <Image
            onClick={handleOpenGallery(event?.images, index)}
            key={image.name}
            src={image.url}
            alt={resolveImageAlt(image, undefined)}
            width={0}
            height={0}
            className="absolute inset-0 z-0 h-full w-full object-cover object-center cursor-pointer hover:opacity-80 transition-all"
            sizes="50vw"
          />
        ))}
      >
        <CarouselControls
          nextIcon={<CgArrowRight size={24} className="text-white" />}
          prevIcon={<CgArrowLeft size={24} className="text-white" />}
          className={{
            main: 'hidden items-center justify-end gap-4 md:flex',
            button:
              'min-h-14 min-w-14 bg-black !text-xl text-white hover:bg-black/95 hover:text-white',
          }}
        />
      </CarouselSection>
    </>
  );
}
